import {
  FETCH_DASHBOARD_HEADERS_FAILURE,
  FETCH_DASHBOARD_HEADERS_REQUEST,
  FETCH_DASHBOARD_HEADERS_SUCCESS,
  FETCH_DASHBOARD_TABLE_FAILURE,
  FETCH_DASHBOARD_TABLE_REQUEST,
  FETCH_DASHBOARD_TABLE_SUCCESS,
} from "../actions/types";

const initialState = {
  dashboardHeadersData: {
    pendingWithdrawlAmount: "",
    totalAvailableCoins: "",
    totalBoostsPurchaseAdIn24hrs: "",
    totalCoinCirculation: "",
    totalCoinTopupIn24hrs: "",
    totalEarningIn24hrs: "",
    totalPendingCoins: "",
    totalRefundAmountIn24hrs: "",
    totalRefundIn24hrs: "",
    totalSalesIn24hrs: "",
    totalTradesIn24hrs: "",
    totalTransactionIn24hrs: "",
  },
  dashboardHeadersLoading: false,
  dashboardHeadersError: null,
  adminTableList: [],
  adminTableListLoading: false,
  adminTableListError: null,
};
export const dashboardHeadersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_HEADERS_REQUEST:
      return {
        ...state,
        dashboardHeadersLoading: true,
      };
    case FETCH_DASHBOARD_HEADERS_SUCCESS:
      return {
        ...state,
        dashboardHeadersLoading: false,
        dashboardHeadersData: action.payload,
      };
    case FETCH_DASHBOARD_HEADERS_FAILURE:
      return {
        ...state,
        dashboardHeadersLoading: false,
        dashboardHeadersError: action.payload,
      };
    case FETCH_DASHBOARD_TABLE_REQUEST:
      return {
        ...state,
        adminTableListLoading: true,
      };
    case FETCH_DASHBOARD_TABLE_SUCCESS:
      return {
        ...state,
        adminTableListLoading: false,
        adminTableList: action.payload,
      };
    case FETCH_DASHBOARD_TABLE_FAILURE:
      return {
        ...state,
        adminTableListLoading: false,
        adminTableListError: false,
        dashboardHeadersError: action.payload,
        adminTableList: [],
      };
    default:
      return state;
  }
};
